export const dollarMask =
  (includeCents: boolean, allowNegative?: boolean) =>
  (value = '') => {
    const isNegative = value.startsWith('-') && allowNegative;
    const [dollarValue, centValue] = (isNegative ? value.substr(1) : value)
      .replace(/,/g, '')
      .split('.');
    const m: (string | RegExp)[] = [];

    if (dollarValue) {
      //push digits and commas
      for (let i = 0; i < dollarValue.length; i++) {
        if (i !== 0 && i % 3 === 0) {
          m.push(',');
        }
        m.push(/\d/);
      }
    }

    if (isNegative) {
      m.push('-');
    }

    m.reverse();

    if (includeCents) {
      if (centValue != null) {
        m.push('.');
        // push up to 2 values
        for (let i = 0; i < Math.min(2, centValue.length); i++) {
          m.push(/\d/);
        }
      }
    }

    return m;
  };

export const percentMask =
  (decimals: number) =>
  (value = '') => {
    const [whole, decimal] = value.split('.');
    const m: (string | RegExp)[] = [];
    for (let i = 0; i < whole.length; i++) {
      m.push(/\d/);
    }

    if (decimals > 0 && decimal != null) {
      m.push('.');
      for (let i = 0; i < Math.min(decimals, decimal.length); i++) {
        m.push(/\d/);
      }
    }
    return m;
  };
